<template>
  <div class="divNavBar">
    <div class="divRightMenu">
      <div class="divLogo">
        <img src="@/assets/logo_v5.png" class="logoImg" @click="jumpToIndex" />
      </div>
      <div class="divContent">
        <img src="@/assets/topNav.png" class="topImg" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    jumpToIndex() {
      sessionStorage.setItem("subjectID", "1");
      this.$router.push("/home");
      this.$trackEvent("顶部研究院图标", "点击图标");
      this.$store.commit("updateToggleImg", false);
    },
  },
};
</script>
<style lang="scss" scoped>
.divNavBar {
  height: 90px;
  width: 100%;
  min-width: 1290px;
  background: #fff;
  box-shadow: 0px 2px 4px 0px rgb(0 0 0 / 7%);
  position: relative;
  z-index: 9;
  .divRightMenu {
    margin: 0 auto;
    width: calc(100% - 90px);
    max-width: 1440px;
    padding:0 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    .divLogo{
      position: relative;
      cursor: pointer;
      height: 90px;
      .logoImg{
        display: block;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        width: 223px;
        // width: 90%;
      }
    }
    .divContent {
      position: relative;
      height: 100px;
      .topImg{
        display: block;
        justify-self: flex-end;
        margin: 0 auto;
        position: relative;
        top: calc(50% + 0px);
        transform: translateY(-50%);
        max-width: 387px;
        // width: 70%;
      }
    }
  }
}
</style>
